import { Component } from '@angular/core';

@Component({
    selector: 'balance-widget',
    templateUrl: 'balance-widget.component.html',
    styleUrls: ['balance-widget.component.less']
})
export class BalanceWidgetComponent {}
